import React from 'react'
import { Location } from '@reach/router'
import { parse } from 'query-string'
import { navigateWithBasepath } from '../App'

const parseSearch = (location) => {
  location.query = parse(location.search)
}
const querySet =
  (location) =>
  ({ ...args }) => {
    const query = parse(location.search)
    Object.assign(query, args)
    for (const [k, v] of Object.entries(query)) if (v === '') query[k] = undefined
    navigateWithBasepath('', { query, replace: true })
  }
const queryDelete = (location) => (key) => {
  const query = parse(location.search)
  delete query[key]
  navigateWithBasepath('', { query, replace: true })
}
const stateSet = (location) => (state) => {
  navigateWithBasepath('', { state, replace: true })
}

export default (WrappedComponent) =>
  ({ ...props }) =>
    (
      <Location>
        {({ location, navigate }) => {
          parseSearch(location)
          location.querySet = querySet(location)
          location.queryDelete = queryDelete(location)
          location.stateSet = stateSet(location)

          return <WrappedComponent {...props} {...{ location, navigate }} />
        }}
      </Location>
    )
